import { useState, useEffect } from 'react';
declare global {
  interface Window {
    clarity?: (command: 'set' | 'event' | 'consent', ...args: unknown[]) => void;
  }
}
export {};
export default function CookieConsent() {
  const [visible, setVisible] = useState(() => !localStorage.getItem('cookie-consent'));

  const handleConsent = (granted: boolean) => {
    localStorage.setItem('cookie-consent', granted ? 'granted' : 'denied');
    window.clarity && window.clarity('consent', granted ? true : false); // 👈 send signal to Clarity
    setVisible(false);
  };
  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (consent) {
      window.clarity && window.clarity('consent', consent === 'granted');
    }
  }, []);
  if (!visible) return null;

  return (
    <div className="fixed bottom-0 w-full bg-gray-800 text-white p-4 flex justify-between items-center">
      <p>We use cookies to analyze traffic and improve your experience.</p>
      <div>
        <button className="bg-green-600 px-4 py-2 rounded mr-2" onClick={() => handleConsent(true)}>
          Accept
        </button>
        <button className="bg-gray-600 px-4 py-2 rounded" onClick={() => handleConsent(false)}>
          Reject
        </button>
      </div>
    </div>
  );
}
